export default {
    loading: false,
    updated: false,
    error: null,
    buyers: [],
    buyer: null,
}
